import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { AiFillStar, AiFillHeart } from "react-icons/ai";
// import "../InfoBook/Intro.css";
import ShareModal from "../components/ShareModalBook";
import { GiCheckMark } from "react-icons/gi";
// import Footer from "../FooterMain/Footer";
// import Header from "../componentbook/HeaderFilesBook/HeaderBook";
import LoadingSpinner from "../components/LoadingSpinner";

import { useNavigate, useLocation } from "react-router-dom";
import { useCookies } from "react-cookie";
// import MetaTags from "../DynamicMetaData/DynamicMetadata";
// Image imports
import typing1 from "../assets/typing1.png";
import typing2 from "../assets/typing2.png";
import typing3 from "../assets/typing3.png";
import typing4 from "../assets/typing4.png";
import typing5 from "../assets/typing5.png";
import typing6 from "../assets/typing6.png";
import typing7 from "../assets/typing7.png";
import typing8 from "../assets/typing8.png";
import typing9 from "../assets/typing9.png";
import BuyButtonTyping from "../components/BuyButtonTyping"; // Import the BuyButtonTyping component
import Modal from "react-bootstrap/Modal";
import { IoIosChatbubbles } from "react-icons/io";
import Chatbot from "../components/chatBot/Chatbot";
import Header from "../components/Header/Header";
// import EbookOfferBanner from "../components/Banner/OfferBanner";
import axios from "axios";
import MatchPopupController from "../MatchProfileContainer.js";
// import ExamOfferBar from "./ExamOfferBar"

function HomePage() {
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const hasStdCoupon = queryParams.has("stdcpncde");
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [currentSlide, setCurrentSlide] = useState(0);
  const { user } = useAuth();
  const [cookies] = useCookies(["token"]);
  const [showChatbot, setShowChatbot] = useState(false);
  const handleChatbotOpen = () => setShowChatbot(true);
  const handleChatbotClose = () => setShowChatbot(false);
  const [finalPrice, setFinalPrice] = useState(299);
  const [totalCoins, setTotalCoins] = useState(0);
  const [redeemCoins, setRedeemCoins] = useState(0);
  const [savedAmount, setSavedAmount] = useState(0);
  const [showMessage, setShowMessage] = useState(false);
  const [coupanInput, setCoupanInput] = useState("");
  const [coupanCode, setCoupanCode] = useState(null);
  const [isCouponValid, setIsCouponValid] = useState(false);
  const [validCoupons, setValidCoupons] = useState([]);
  const [discount, setDiscount] = useState(0);
  const [showMenu, setShowMenu] = useState(false);
  const [feedbackData, setFeedbackData] = useState(null);
  const instParam = queryParams.get("Inst");
  const BASE_PRICE = 299;
  useEffect(() => {
    axios
      .get("https://auth.ssccglpinnacle.com/api/v1/typing/feedback")
      .then((res) => setFeedbackData(res.data))
      .catch((err) => console.error("API error:", err));
  }, []);

  const images = [
    typing1,
    typing2,
    typing3,
    typing4,
    typing5,
    typing6,
    typing7,
    typing8,
    typing9,
  ];
  const [typingDiscount, settypingDiscount] = useState(null);
  const [typingMaxDiscount, setTypingMaxDiscount] = useState(null);

  useEffect(() => {
    const fetchDiscount = async () => {
      try {
        const res = await fetch(
          "https://nodei.ssccglpinnacle.com/api/product-discounts",
        );
        const result = await res.json();

        const discountsArray = result.data;
        const ebookEntry = discountsArray.find(
          (item) => item.category === "typing",
        );

        if (ebookEntry) {
          settypingDiscount(ebookEntry.minDiscount);
          setTypingMaxDiscount(ebookEntry.maxDiscount);
        }
      } catch (error) {
        console.error("Error fetching discount data:", error);
      }
    };

    fetchDiscount();
  }, []);

  useEffect(() => {
    const fetchCoupons = async () => {
      try {
        const res = await fetch("https://nodei.ssccglpinnacle.com/get-mentors");
        const data = await res.json();
        const coupons = data
          .map((mentor) => mentor.coupancode?.trim())
          .filter(Boolean);
        setValidCoupons(coupons);
      } catch (err) {
        console.error("Error fetching coupons:", err);
      }
    };
    fetchCoupons();
  }, []);

  useEffect(() => {
    setFinalPrice(BASE_PRICE);
    setDiscount(0);
    setSavedAmount(0);
    setIsCouponValid(false);
  }, [coupanInput]);

  const applyCoupon = async () => {
    if (coupanInput && validCoupons.includes(coupanInput)) {
      // const discountApplied = Math.floor(finalPrice * 0.1); // 10%
      const discountPercentage = typingDiscount || 0;
      const discountApplied = Math.floor(299 * (discountPercentage / 100));
      setDiscount(discountApplied);
      setFinalPrice(finalPrice - discountApplied);
      setIsCouponValid(true);
      setCoupanCode(coupanInput);

      try {
        const response = await fetch(
          "https://auth.ssccglpinnacle.com/typingCoupan",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              email: user?.email_id,
              coupanCode: coupanInput,
            }),
          },
        );

        const result = await response.json();

        if (!response.ok) {
          console.error("Backend error:", result.error || "Unknown error");
        } else {
          console.log("Coupon logged successfully:", result);
        }
      } catch (error) {
        console.error("Error calling backend API:", error);
      }
    }
  };

  useEffect(() => {
    if (coupanInput && validCoupons.includes(coupanInput) && !isCouponValid) {
      handleApplyCouponAuto(coupanInput);
    }
  }, [coupanInput, validCoupons, isCouponValid]);

  const handleApplyCouponAuto = async (code) => {
    if (isCouponValid) return;

    const discountPercentage = typingDiscount || 0;
    const discountApplied = Math.floor((BASE_PRICE * discountPercentage) / 100);

    setDiscount(discountApplied);
    setFinalPrice(BASE_PRICE - discountApplied);
    setIsCouponValid(true);
    setCoupanCode(code);

    try {
      await fetch("https://auth.ssccglpinnacle.com/typingCoupan", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: user?.email_id,
          coupanCode: code,
        }),
      });
    } catch (err) {
      console.error("Coupon log error:", err);
    }
  };

  useEffect(() => {
    const fetchCoins = async () => {
      try {
        const response = await fetch(
          `https://auth.ssccglpinnacle.com/api/coins/${user?._id}`,
          {
            headers: {
              Authorization: `Bearer ${cookies.token}`,
            },
          },
        );

        if (!response.ok) {
          throw new Error("Failed to fetch coin data");
        }

        const result = await response.json();
        const coins =
          result.data?.reduce((sum, item) => sum + (item.coins || 0), 0) || 0;
        setTotalCoins(coins);
      } catch (error) {
        console.error("Error fetching coins:", error.message);
      }
    };

    if (user?._id) {
      fetchCoins();
    }
  }, [user, cookies.token]);

  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % images.length);
    }, 3000);

    return () => clearInterval(slideInterval);
  }, [images.length]);

  useEffect(() => {
    setLoading(false);
  }, []);

  if (loading) {
    return <LoadingSpinner />;
  }
  const handleRedeemCoins = () => {
    const currentBase = finalPrice;
    let discountApplied = 0;

    if (!isCouponValid && coupanInput && validCoupons.includes(coupanInput)) {
      discountApplied = Math.floor(currentBase * 0.1);
      setIsCouponValid(true);
      setCoupanCode(coupanInput);
    }

    const priceAfterDiscount = currentBase - discountApplied;
    const coinsToUse = redeemCoins > 0 ? redeemCoins : 0;
    const finalCalculatedPrice = priceAfterDiscount - coinsToUse;

    if (coinsToUse <= totalCoins && finalCalculatedPrice >= 1) {
      setDiscount((prev) => prev + discountApplied);
      setSavedAmount((prev) => prev + coinsToUse);
      setTotalCoins(totalCoins - coinsToUse);
      setFinalPrice(finalCalculatedPrice);
      setRedeemCoins(0);
      setShowMessage(true);
      setTimeout(() => setShowMessage(false), 3000);
    } else {
    }
  };

  return (
    <>
     {/* <ExamOfferBar
        couponCode="SP10"
        discountText="10% OFF"
        endAt="2026-08-16T23:59:59+05:30"
        onCouponCopy={(code) => {
          window.dataLayer?.push({
            event: "coupon_copied",
            coupon: code,
          });
        }}
      /> */}
      <Header />
      {/* <MatchPopupController /> */}
      {/* <EbookOfferBanner /> */}
      <div className="max-w-screen-xl mx-auto px-5 py-10">
        <div className="grid md:grid-cols-2 gap-10">
          {/* Image Section */}
          <div className="flex flex-col items-center">
            <div className="rounded-lg overflow-hidden shadow-lg">
              <img
                className="w-full h-auto object-cover"
                src={images[currentSlide]}
                alt={`Slide ${currentSlide + 1}`}
              />
            </div>
            <div className="mt-6 flex justify-center w-full ">
              <BuyButtonTyping
                // userDetails={user}
                // redeemcoins={savedAmount}
                userDetails={user}
                redeemcoins={savedAmount}
                finalPrice={finalPrice}
                discount={discount}
                coupanCode={coupanCode}
                maxDiscount={typingMaxDiscount}
                className=" w-full bg-blue-500 text-white text-lg text-sm py-3 rounded-sm shadow-md transition duration-300 hover:bg-blue-600 focus:ring focus:ring-blue-300"
              />
            </div>
          </div>

          <div>
            {/* <h2 className="text-[38px] font-bold  text-gray-800"> */}
            <h2 className="text-4xl font-medium text-gray-900 leading-snug">
              Pinnacle Typing Software based on Pattern: SSC CGL | CHSL Tier 2
            </h2>

            <div className="flex items-center gap-3 text-lg  mt-3">
              {feedbackData && (
                <div className="flex items-center gap-2 mt-2">
                  <span className="bg-green-600 text-white text-sm px-2 py-1 rounded font-semibold flex items-center">
                    {feedbackData.averageRating
                      ? feedbackData.averageRating?.toFixed(1)
                      : "0.0"}
                    <AiFillStar className="items-center ml-1 items-center" />
                  </span>

                  <span className="text-gray-600 text-sm font-medium items-center">
                    ({feedbackData.totalRatings.toLocaleString()})
                  </span>
                </div>
              )}

              <p className="line-through text-base text-red-500 items-center">
                ₹999
              </p>
              <p className="text-green-600 text-base">₹{finalPrice}</p>

              <button className="px-5 items-center py-2 bg-blue-200 text-gray-900 text-sm italic rounded-full shadow-md transition duration-300 hover:bg-blue-300 focus:ring focus:ring-blue-300">
                VALUE DEAL! Save
              </button>

              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="green"
              >
                <circle cx="18" cy="5" r="3" />
                <circle cx="6" cy="12" r="3" />
                <circle cx="18" cy="19" r="3" />
                <line
                  x1="8.59"
                  y1="13.51"
                  x2="15.42"
                  y2="17.49"
                  stroke="green"
                  strokeWidth="2"
                />
                <line
                  x1="15.41"
                  y1="6.51"
                  x2="8.59"
                  y2="10.49"
                  stroke="green"
                  strokeWidth="2"
                />
              </svg>
              <ShareModal
                product={{
                  id: 999,
                  title: "Typing",
                  price: 299,
                  slug: "typing-pass",
                }}
                userEmail={user?.email_id}
              />
            </div>

            {!hasStdCoupon && !instParam && (
              <div className="mt-3">
                <input
                  type="text"
                  value={coupanInput}
                  onChange={(e) =>
                    !isCouponValid &&
                    setCoupanInput(e.target.value.toUpperCase().trim())
                  }
                  placeholder="Enter coupon code"
                  className="border p-2 rounded w-60 mb-2 text-sm"
                  readOnly={isCouponValid}
                />

                {/* <button
                  onClick={applyCoupon}
                  className={`ml-2 px-4 py-2 rounded ${
                    isCouponValid || !validCoupons.includes(coupanInput)
                      ? "bg-gray-300 cursor-not-allowed text-gray-600"
                      : "bg-green-500 text-white hover:bg-green-600"
                  }`}
                  disabled={
                    isCouponValid || !validCoupons.includes(coupanInput)
                  }
                >
                  {isCouponValid ? "Applied" : "Apply"}
                </button> */}

                {isCouponValid && discount > 0 && (
                  <p className="text-green-600 text-sm font-medium mt-1">
                    Coupon "{coupanCode}" applied! Discount: ₹{discount}
                  </p>
                )}
              </div>
            )}
            {!instParam && (
              <div className="flex mt-2">
                <input
                  type="number"
                  className="redeem-input"
                  value={redeemCoins || ""}
                  onChange={(e) => setRedeemCoins(Number(e.target.value) || 0)}
                  placeholder="Enter Coins to redeem"
                  onWheel={(e) => e.target.blur()}
                />
                <button
                  className="w-40 bg-blue-500 text-white text-lg text-sm py-3 rounded-sm shadow-md transition duration-300 hover:bg-blue-200 focus:ring focus:ring-blue-200"
                  onClick={handleRedeemCoins}
                  disabled={redeemCoins <= 0 || redeemCoins > totalCoins}
                >
                  Redeem Coins
                </button>
              </div>
            )}
            {!instParam && (
              <h5 className="text-lg font-bold text-yellow-600 mt-2">
                {user ? (
                  <>
                    Total Coins Earned: {totalCoins}
                    {totalCoins === 0 ? (
                      <span className="text-blue-500 ml-2 text-sm font-normal">
                        Scan Pinnacle Book barcode to earn coins!
                      </span>
                    ) : (
                      <a
                        href="https://typing.ssccglpinnacle.com/coins"
                        target="_blank"
                        className="ml-2 text-sm text-teal-600 font-normal"
                      >
                        Check Coins Detail
                      </a>
                    )}
                  </>
                ) : (
                  <a
                    href="https://testportal.ssccglpinnacle.com/login"
                    className="text-red-600 font-medium text-base mt-2  "
                  >
                    Login and use your coins!
                  </a>
                )}
              </h5>
            )}
            {showMessage && (
              <div className="celebration-message">
                🎉 Congrats! You have saved ₹{savedAmount}! 🎉
              </div>
            )}

            <div className="mt-3 space-y-3">
              <p className="text-gray-800">
                This is unique typing software designed specially for SSC CGL
                Tier 2 and SSC CHSL Tier 2 exam. Important features of this
                typing software are:
              </p>
              <p className="text-red-600">
                Please note: Rs 299 fee is for one year subscription as a
                special offer. For those who could not purchase till today 11:59
                pm, fee will be Rs 999/- for one year i.e. yearly
                subscription.&nbsp;
              </p>
              <div className="mt-6 space-y-3 text-lg text-gray-800 font-normal text-base">
                <p className="flex items-center text-base text-sm">
                  <GiCheckMark className="text-gray-500 mr-2" />
                  {/* <a
                    href="https://testseries.ssccglpinnacle.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 font-semibold underline text-sm"
                  > */}
                  like interface typing software
                  {/* </a> */}
                </p>
                <p className="flex items-center text-sm">
                  <GiCheckMark className="text-gray-500 mr-2 text-sm" />
                  Exam wise typing like SSC CGL Tier 2, SSC CHSL Tier 2
                </p>
                <p className="flex items-center text-sm">
                  <GiCheckMark className="text-gray-500 mr-2 text-sm" />
                  Category wise report like UR, OBC, SC etc
                </p>
                <p className="flex items-center text-sm">
                  <GiCheckMark className="text-gray-500 mr-2 text-sm" />
                  Previous year papers /paragraph for typing
                </p>
                <p className="flex items-center text-sm">
                  <GiCheckMark className="text-gray-500 mr-2 text-sm" />
                  Practice sets based on real exam pattern typing
                </p>
                <p className="flex items-center text-sm">
                  <GiCheckMark className="text-gray-500 mr-2 text-sm" />8 types
                  analysis report
                </p>
                <p className="flex items-center text-sm">
                  <GiCheckMark className="text-gray-500 mr-2 text-sm" />
                  Timing, error as per SSC syllabus and instructions.
                </p>
                <p className="flex items-center text-sm">
                  <GiCheckMark className="text-gray-500 mr-2 flex-shrink-0" />
                  <span>
                    Can do typing through{" "}
                    <a
                      href="https://play.google.com/store/apps/details?id=com.ssccgl.pinnacle.testportal"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 font-semibold underline mx-1"
                    >
                      Pinnacle exam preparation mobile app
                    </a>{" "}
                    also if anybody does not have a laptop/desktop.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Chatbot Icon */}
      <div className="fixed bottom-4 right-4">
        <IoIosChatbubbles
          onClick={handleChatbotOpen}
          size={50}
          className="cursor-pointer text-blue-500"
        />
      </div>

      {/* Chatbot Modal */}
      <Modal show={showChatbot} onHide={handleChatbotClose} centered>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <Chatbot />
        </Modal.Body>
      </Modal>
    </>
  );
}

export default HomePage;
